"use strict";
import { HoverableValueMixin } from "./hoverable_value_mixin";
var HoverableValueTable = React.createClass({
  mixins: [HoverableValueMixin],
  getInitialState: function() {
    return {};
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("table", { className: "load-detail__info-table load-detail__info-table--vertical" }, /* @__PURE__ */ React.createElement("tbody", null, _.map(this.props.items, this.referenceRow)));
  },
  referenceRow: function(item, index) {
    return /* @__PURE__ */ React.createElement("tr", { key: "reference_row_" + index }, /* @__PURE__ */ React.createElement("th", null, item.name), /* @__PURE__ */ React.createElement("td", null, this.showValue(item)));
  },
  showValue: function(item) {
    if (item.hoverable) {
      return this.showHoverableValue(item.value);
    } else {
      const value = item.value;
      return /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "hoverable-value-table__value"
        },
        value
      );
    }
  }
});
export default HoverableValueTable;
